import { render, staticRenderFns } from "./depot_info.vue?vue&type=template&id=080d4d53&scoped=true&"
import script from "./depot_info.vue?vue&type=script&lang=js&"
export * from "./depot_info.vue?vue&type=script&lang=js&"
import style0 from "./depot_info.vue?vue&type=style&index=0&id=080d4d53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d4d53",
  null
  
)

export default component.exports